import { render, staticRenderFns } from "./PointBitcashFormSet.vue?vue&type=template&id=35f4bc14"
import script from "./PointBitcashFormSet.vue?vue&type=script&lang=js"
export * from "./PointBitcashFormSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports